import { useEffect, useState } from "react";
import { priceEventTarget } from "../components/PriceDisplay/getProductPriceData";
import { productPricingService } from "../services/productPricingService";
import { PRICE_UPDATE_EVENT } from "../types/pricing/price-display.types";
import { ProductPriceDetails } from "../types/pricing/product-price-details.types";

export function usePricingDetails(priceQueryKey: string): ProductPriceDetails | undefined {
  const [priceDetails, setPriceDetails] = useState<ProductPriceDetails | undefined>();

  useEffect(() => {
    const handleUpdate = () => {
      const updated = productPricingService.pricingDetails[priceQueryKey];
      if (updated) {
        setPriceDetails(updated);
      }
    };

    handleUpdate();

    priceEventTarget.addEventListener(PRICE_UPDATE_EVENT, handleUpdate);
    return () => {
      priceEventTarget.removeEventListener(PRICE_UPDATE_EVENT, handleUpdate);
    };
  }, [priceQueryKey]);

  return priceDetails;
}
